import { CoastPopUpMessage } from "../../../../core/lib/auth/backends/pws";
import Heading from "../../../../core/ui/Heading.component";
import "./CoastPopUpMessageModal.style.scss";
import { UsersButton } from "./common/UsersButton.components";
import { UsersFauxButton } from "./common/UsersFauxButton.components";

interface CoastPopUpMessageModalProps {
    message: CoastPopUpMessage;
}

export const CoastPopUpMessageModal = ({ message: { title, text, button, link } }: CoastPopUpMessageModalProps) => {
    return (
        <div className="component-coast-popup-message-modal">
            <Heading level={3}>{title}</Heading>
            {text ? <p>{text}</p> : null}
            {button ? <UsersButton click={button.click}>{button.text}</UsersButton> : null}
            {link ? (
                <UsersFauxButton target={link.target} to={link.url}>
                    {link.text}
                </UsersFauxButton>
            ) : null}
        </div>
    );
};
